button.downloadButton {
	flex-shrink: 0;
	white-space: nowrap;
}

.downloadButtonContent {
	display: flex;
	align-items: center;
	gap: 10px;
}